import { StyledDialog } from '@blackhyve/common';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { useState } from 'react';

import { useGetTaskStuckPointsQuery } from '../store/stuckPoint.api';
import { StuckPointForm } from './AddStuckPointForm';
import StuckPointTable from './StuckPointTable';

/**
 * Get stuck point list
 * @param {Boolean} open
 * @param {String} taskId
 * @param {String} projectId
 * @param {Boolean} handleClose
 * @returns
 */
const StuckPointDialog = ({ taskId, projectId, open, handleClose }) => {
  const { data: stuckPoints = [], isLoading, isFetching } = useGetTaskStuckPointsQuery({ taskId });

  const [displayAddStuckPoint, setDisplayAddStuckPoint] = useState(false);

  return (
    <StyledDialog handleClose={handleClose} maxWidth={'lg'} open={open} title="Stuck Points">
      <Grid container gap={1}>
        {displayAddStuckPoint && (
          <Paper elevation={2}>
            <Grid container item gap={1} p={2} xs={12}>
              <Typography sx={{ fontWeight: 'bold' }} variant="h6">
                Add Stuck Point
              </Typography>
              {displayAddStuckPoint && (
                <StuckPointForm
                  handleClose={() => setDisplayAddStuckPoint(false)}
                  projectId={projectId}
                  taskId={taskId}
                />
              )}
            </Grid>
          </Paper>
        )}
        <Button variant="text" onClick={() => setDisplayAddStuckPoint((prev) => !prev)}>
          {displayAddStuckPoint ? '' : '+ ADD STUCK POINT'}
        </Button>
        <Grid item xs={12}>
          <Paper elevation={3}>
            <StuckPointTable
              isFetching={isFetching}
              isLoading={isLoading}
              stuckPoints={stuckPoints}
            />
          </Paper>
        </Grid>
      </Grid>
    </StyledDialog>
  );
};

export default StuckPointDialog;
